import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import Condition from "./parts/Condition";
import { TreeTable } from 'primereact/components/treetable/TreeTable';
import { Column } from 'primereact/components/column/Column';
import { translate } from "../base/Translation";

export default class StatisticEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_statistic: "/statistic/save/:statistic",
			get_statistic: "/statistic/fetch/:statistic?withStats=:withStats",
			get_weaves: "/weave/fetch/all?limit_from=:from&limit_max=:to&withForms=:withForms&withBranches=:withBranches&withUsers=:withUsers&withCities=:withCities",
			get_weave_groups: "/weave_group/fetch/all?limit_from=:from&limit_max=:to",
		});

		this.state = {
			statistic: false,
			weaves: [],
			weave_groups: [],
			selectedWeave: null
		};
	}

	saveData() {
		let statistic = this.state.statistic;

		statistic.results = false;

		// clear other weave params
		statistic.weave = statistic.weave.id ? statistic.weave.id : 0;

		// clear other weave group  params
		statistic.weave_group = statistic.weave_group.id ? statistic.weave_group.id : 0;

		this.api.request({
			route: "save_statistic",
			params: { statistic: this.props.params.statisticID },
			data: statistic,
			created: (response) => {
				//eslint-disable-next-line
				location.reload();
			}
		});
	}

	fetchData() {
		this.api.request({
			route: "get_statistic",
			params: { statistic: this.props.params.statisticID, withStats: true },
			success: (statistic) => {

				this.api.request({
					cache: true,
					route: "get_weaves",
					params: { from: 0, to: 99999, withForms: true, withBranches: true, withUsers: true },
					success: (response) => {
						
						this.setState({
							weaves: response,
							selectedWeave: response.find((weave) => {
								return weave.id === (statistic.weave ? statistic.weave.id : statistic.weave);
							})
						});
					}
				});

				this.api.request({
					cache: true,
					route: "get_weave_groups",
					params: { from: 0, to: 99999, withForms: true, withBranches: true },
					success: (response) => {
						this.setState({
							weave_groups: response
						});
					}
				});

				this.setState({ statistic });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onStatisticChange(evt) {
		// Get data from state
		let newData = this.state.statistic;

		// Update it's value
		newData[evt.target.name] = evt.target.value;

		if (evt.target.name === "weave") {

			// Find selected weave by id from the weave list, so we can work with object
			const selectedWeave = this.state.weaves.find((weave) => {
				return weave.id === parseInt(newData.weave, 10);
			});

			newData.weave = typeof selectedWeave === "undefined" ? 0 : selectedWeave;

			// Reset filter on weave change
			this.state.statistic.filters = [];

			// Set the new state
			this.setState({
				statistic: newData
			});

			return;
		}

		if (evt.target.name === "weave_group") {

			// Find selected weave by id from the weave list, so we can work with object
			const selectedWeaveGroup = this.state.weave_groups.find((weave) => {
				return weave.id === parseInt(newData.weave_group, 10);
			});

			newData.weave_group = typeof selectedWeaveGroup === "undefined" ? 0 : selectedWeaveGroup;

			// Reset filter on weave change
			this.state.statistic.filters = [];

			// Set the new state
			this.setState({
				statistic: newData
			});

			return;
		}

		// Additional update
		if (evt.target.name === "type") {
			if (evt.target.value === "weave_group") {
				newData.weave = { id: 0 };
			} else if (evt.target.value === "weave") {
				newData.weave_group = { id: 0 };
			} else {
				newData.weave = { id: 0 };
				newData.weave_group = { id: 0 };
			}
		}

		// Update data in state
		this.setState({ statistic: newData });
	}

	onStatisticSave(evt) {
		this.saveData();
	}

	/*
	 *
	 * Render methods
	 *
	 */
	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	renderFilter() {
		return (
			<div>
				{(this.state.statistic.filters ? this.state.statistic.filters : []).map((or, orindex) => {
					return (
						<div key={orindex}>
							{orindex > 0 ? <hr /> : ""}
							<div className="form-group filters">
								{or.map((condition, condindex) => {
									return this.renderCondition(condition, condindex, orindex);
								})}
							</div>
						</div>
					)
				})}
				<div className="form-group">
					<button className="btn btn-primary" onClick={(evt) => {
						let statistic = this.state.statistic;
						statistic.filters.push([{ param: "answer", operator: "is", value: 0 }]);
						this.setState({ statistic });
					}}>{translate("Pridať skupinu podmienok")}</button>
				</div>
			</div>
		)
	}

	renderCondition(condition, condindex, orindex) {
		return <Condition
			key={condindex}
			weave={this.state.statistic.weave}
			data={condition}
			onParamChange={(param) => {
				let statistic = this.state.statistic;

				statistic.filters[orindex][condindex].param = param;

				this.setState({ statistic });
			}}
			onOperatorChange={(operator) => {
				let statistic = this.state.statistic;

				statistic.filters[orindex][condindex].operator = operator;

				this.setState({ statistic });
			}}
			onValueChange={(value) => {
				let statistic = this.state.statistic;

				statistic.filters[orindex][condindex].value = value;

				this.setState({ statistic });
			}}
			onDelete={() => {
				let statistic = this.state.statistic;

				statistic.filters[orindex].splice(condindex, 1);

				if (statistic.filters[orindex].length === 0) {
					statistic.filters.splice(orindex, 1);
				}

				this.setState({ statistic });
			}}
			onAdd={() => {
				let statistic = this.state.statistic;

				statistic.filters[orindex].push({ param: "answer", operator: "is", value: 0 });

				this.setState({ statistic });
			}}
		/>
	}

	renderWeaveOrGroupSelect() {

		if (this.state.statistic.type === "weave_group") {
			return (
				<FormGroup>
					<ControlLabel>{translate("Skupina vĺn")}</ControlLabel>
					<select disabled className="form-control" value={typeof this.state.statistic.weave_group !== "object" ? this.state.statistic.weave_group : this.state.statistic.weave_group.id} name="weave_group" onChange={this.onStatisticChange.bind(this)}>
						<option value={0}>{translate("Vyberte")}</option>
						{this.renderOptions(this.state.weave_groups)}
					</select>
				</FormGroup>
			)
		} else if (this.state.statistic.type === "weave") {
			return (
				<FormGroup>
					<ControlLabel>{translate("Vlna")}</ControlLabel>
					<select disabled className="form-control" value={typeof this.state.statistic.weave !== "object" ? this.state.statistic.weave : this.state.statistic.weave.id} name="weave" onChange={this.onStatisticChange.bind(this)}>
						<option value={0}>{translate("Vyberte")}</option>
						{this.renderOptions(this.state.weaves)}
					</select>
				</FormGroup>
			)
		}

		return "";
	}

	renderRestOfTheForm() {

		if ([null, 0, ""].indexOf(this.state.statistic.type) !== -1) {
			return "";
		}

		return (
			<div>
				{this.renderWeaveOrGroupSelect()}
				<h4>{translate("Pravidlá")}</h4>
				{this.renderFilter()}
			</div>
		)
	}

	render() {

		if (!this.state.statistic) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			)
		}

		return (
			<Page>
				<PageHeader title={this.state.statistic.name} />
				<PageBody>
					<Row>
						<Col lg={12}>
							<Panel header={translate("Štatistika")}>
								<Row>
									<Col lg={8} sm={12}>
										<FormGroup>
											<ControlLabel>{translate("Názov")}</ControlLabel>
											<FormControl name="name" defaultValue={this.state.statistic.name} onChange={this.onStatisticChange.bind(this)} />
										</FormGroup>

										<FormGroup>
											<ControlLabel>{translate("Typ")}</ControlLabel>
											<select disabled className="form-control" defaultValue={this.state.statistic.type} name="type" onChange={this.onStatisticChange.bind(this)}>
												<option value={0}>{translate("Vyberte")}</option>
												{this.renderOptions([
													{
														"id": "weave",
														"name": "Vlna"
													}, {
														"id": "weave_group",
														"name": "Skupina vĺn"
													},
												])}
											</select>
										</FormGroup>

										{this.renderRestOfTheForm()}
									</Col>
								</Row>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onStatisticSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<h3>{translate("Náhľad štatistiky")}</h3>
							<div style={{ paddingBottom: "1rem" }}>
								<span>{translate("Testy zahrnuté podľa pravidiel:")} </span>
								{(this.state.statistic.tests ? this.state.statistic.tests : []).map((test, index) => {
									return <span key={index}>{test + (index < this.state.statistic.tests.length - 1 ? ", " : "")}</span>
								})}
							</div>
							<TreeTable value={this.state.statistic.results} >
								<Column field="name" header={translate("Názov")} style={{ borderBottom: "1px solid #e1e1e1", textAlign: "left" }}></Column>
								<Column field="type" header={translate("Typ")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "left" }}></Column>
								<Column field="answerCount" header={translate("Počet odpovedí")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "center" }}></Column>
								<Column field="percent" header={translate("Percento")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "center" }}></Column>
							</TreeTable>
						</Col>
						<Col lg={12}>
							<br />
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}





// WEBPACK FOOTER //
// ./src/modules/statistic/StatisticEdit.jsx